
export default {
    translation: {
        "change to": "zmien na",
        "english": "angielski",
        "polish": "polski",
        "refresh page": "odswiez strone",
        "updatedBookDetails": "Zaktualizowane szczegóły książki",
        "submit": "Wysli",
        "search": "Wyszukaj",
        "areyousure": "Czy na pewno chcesz sprzedać wybraną książkę?",
        "listbook": "Lista Książek",
        "no": "Nie",
        "yes": "Tak",
        "sell": "Sprzedaj",
        "accessible": "Dostępne",
        "number of available items": "Liczba dostępnych pozycji",
        "mybasket": "Moj Koszyk",
        "basket" : "Koszyk",
        "nocartitems": "Brak elementów koszyka",
        "add-new-book": "Dodaj nową książke",
        "title": "Tytuł",
        "pages": "Strony:",
        "addProduct": "Dodaj produkt",
        "preview-new-book": "Podgląd nowej książki",
        "page-count": "Liczba stron",
        "date-added": "Data dodania",
        "authors" : "Autory",
        "mainpage" : "Strona główna",
        "addproduct" : "Dodaj product",
        "editproduct" : "Edytuj produkt",
        "sellproduct" : "Sprzedaj produkt",
        "add" : "Dodaj",
        "edit" : "Edytuj",
        "sortby" : "Sortuj po",
        "booksshow" : "Liczba dostępnych pozycji",
        "showdetails" : "Pokaż szczegóły",
        "bookdetails" : "Szczegóły książki",
        "backtoprojects" : "Powrót Projecty"
    },
};